export default "__VITE_ASSET__vsTeRbOO__"